// Sizing is required for Dagre layout calculations
export const LABEL_HEIGHT = 14;

const DEFAULT_TEXT_WIDTH = 80;
const DEFAULT_X_PADDING = 58;

const canvas = document.createElement('canvas');

export function getTextBoundingBox(
  text: string,
  font: CanvasTextDrawingStyles['font'],
  defaultTextWidth = DEFAULT_TEXT_WIDTH,
  xPadding = DEFAULT_X_PADDING,
  labelHeight = LABEL_HEIGHT,
) {
  const context = canvas.getContext('2d');
  // In older browsers, we may have to use consistently sized Nodes in the DAG
  if (!context) return { width: defaultTextWidth + xPadding, height: labelHeight };
  context.font = font;
  const { width } = context.measureText(text);
  return { width: width + xPadding, height: labelHeight };
}
